export default from './MultiSelector';



// WEBPACK FOOTER //
// ./src/components/MultiSelector/index.js


// WEBPACK FOOTER //
// webpack:///src/components/MultiSelector/index.js